import React, { Component } from "react"
import axios from "axios"
import moment from "moment"
import { Modal, Button, Spinner, FormControl } from "react-bootstrap"
import ReactQuill from "react-quill-v2.0"
import AxiosConfig from "../../../../../../../utilities/AxiosConfig"
import reggie from "../../../../../../../utilities/Reggie"
import snackBar from "../../../../../../../utilities/snackBar/SnackBar"
import ReviewTimelineTypes from "../../ReviewTypes/ReviewTimelineTypes"
import "./TimelineTextEditor.css"

interface TimelineTextEditorProps {
    toggleTextEditor: Function
    refreshTimeline: Function
    EmployeeReviewTimelineTypeId: number
    contextUserId: string | number
    EmployeeReviewId: number
    EmployeeReviewTimelineId?: number
    item?: ReviewTimelineTypes
}

type TimelineTextEditorTypes = {
    input: string
    title: string
    dirty: boolean
    saving: boolean
}

class TimelineTextEditor extends Component<TimelineTextEditorProps, TimelineTextEditorTypes> {


    formats = [
        "font", "color",
        "header",
        "bold", "italic", "underline", "strike", "blockquote",
        "list", "bullet", "indent",
        "link"
    ]


    state = {
        input: "",
        title: "",
        dirty: false,
        saving: false
    }

    reference = [
        { id: 1, text: "Document" },
        { id: 2, text: "Correspondence" },
        { id: 3, text: "Note" },
        { id: 4, text: "Event" },
        { id: 5, text: "Form" },
        { id: 6, text: "Activity" },
    ]

    componentDidMount() {
        if (this.props.item) {
            this.setState({ title: this.props.item.TimelineTitle, input: this.props.item.NoteText })
        }
    }

    handleQuill = (input: string) => {
        this.setState({ input: input })
    }

    handleChange = (event: { target: { value: string } }) => {
        this.setState({ title: event.target.value })
    }

    createOrUpdateTimelineItem = () => {
        this.setState({ saving: true })
        let rb: any = {
            EmployeeReviewTimelineId: this.props.EmployeeReviewTimelineId,
            EmployeeReviewId: this.props.EmployeeReviewId,
            EmployeeReviewTimelineTypeId: this.reference[this.props.EmployeeReviewTimelineTypeId - 1].id,
            TimelineTitle: this.state.title,
            // TimelineTitle: this.reference[this.props.EmployeeReviewTimelineTypeId - 1].text,
            TimelineDateUTC: moment().format(),
            LinkedToId: null,
            DeletedDateUTC: null,
            DeletedBy: null,
            DisabledDateUTC: null,
            DisabledBy: null,
            NoteText: this.state.input,
            IsLocked: true
        }

        if (this.props.item) {
            rb.ModifyDateUTC = moment().format()
            rb.ModifiedBy = this.props.contextUserId
        } else {
            rb.CreatedDateUTC = moment().format()
            rb.CreatedBy = this.props.contextUserId
        }

        axios.post(process.env.REACT_APP_API_URL + "/api/employeeReview/addOrUpdateReviewTimeline", rb, AxiosConfig.configValue("min"))
            .then(res => {
                this.setState({ saving: false })
                if (!this.props.item) {
                    this.props.toggleTextEditor([{ key: "addEvent" }, { key: "addEventType" }])
                    snackBar({ type: "success", text: `${this.reference[this.props.EmployeeReviewTimelineTypeId - 1].text} added`, timeout: 3000 })
                } else {
                    this.props.toggleTextEditor([{ key: "edit" }, { key: "editIndex", value: -1 }])
                    snackBar({ type: "success", text: `${this.reference[this.props.EmployeeReviewTimelineTypeId - 1].text} edited`, timeout: 3000 })
                }
                this.props.refreshTimeline()
            }).catch(err => {
                //console.log(err)
                this.setState({ saving: false })
                snackBar({ type: "error", text: "Encountered an error during the file upload process", timeout: 3000 })
            })
    }

    render() {

        let canSave = reggie.filterTags(this.state.input) !== "" && this.state.title !== ""
        // if(this.props.item){
        //     canSave = reggie.filterTags(this.props.item.NoteText) !== reggie.filterTags(this.state.input) && this.props.item.TimelineTitle !== this.state.title
        // }
        let hasTitle = this.state.title !== ""

        return (
            <Modal id="timeline-large-view-modal"
                show={true}
                backdrop="static"
                keyboard={true}
                centered={true}
                size="xl"
            >
                <Modal.Header>
                    <div className="TimelineTextEditorHeader">
                        <p>Add {this.reference[this.props.EmployeeReviewTimelineTypeId - 1].text}</p>
                        <div className="TimelineTextEditorHeaderTitleWrapper">
                            <div className="TimelineTextEditorHeaderTitleWrapperLeft">
                                {hasTitle && <span id="timeline-text-editor-title-wrapper-can-save" className="material-icons">done</span>}
                                {!hasTitle && <span id="timeline-text-editor-title-wrapper-cant-save" className="material-icons">close</span>}
                            </div>
                            <div className="TimelineTextEditorHeaderTitleWrapperRight">
                                <FormControl
                                    placeholder={`${this.reference[this.props.EmployeeReviewTimelineTypeId - 1].text} title`}
                                    aria-describedby="basic-addon1"
                                    onChange={this.handleChange}
                                    value={this.state.title}
                                />
                            </div>
                        </div>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <div className="TimelineTextEditorBody">
                        <ReactQuill
                            value={this.state.input}
                            onChange={this.handleQuill}
                            formats={this.formats}
                        />
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <div className="TimelineTextEditorFooter">
                        {!this.state.saving && !this.props.item && <Button variant="secondary" onClick={() => this.props.toggleTextEditor([{ key: "addEvent" }, { key: "addEventType" }])}>Back</Button>}
                        {!this.state.saving && this.props.item && <Button variant="secondary" onClick={() => this.props.toggleTextEditor([{ key: "edit" }, { key: "editIndex", value: -1 }])}>Back</Button>}
                        {!this.state.saving && canSave && <Button variant="primary" onClick={() => this.createOrUpdateTimelineItem()}>Save</Button>}
                        {this.state.saving && <Spinner id="timeline-text-editor-save-spinner" animation="border" />}
                    </div>
                </Modal.Footer>
            </Modal>
        )
    }
}

export default TimelineTextEditor